import React from "react";
import { ITopic } from "../../../../models/topics/topic";
import { Chip } from "../../../chip/Chip";
import styles from "./topicList.css";

interface Props {
  topics: ITopic[];
  onDelete?: (topic: ITopic) => void;
}
export const TopicList = ({ topics, onDelete }: Props) => {
  return (
    <div className={styles.list}>
      {topics.map((t) => (
        <Chip key={t.id} label={t.name} onDelete={onDelete && (() => onDelete(t))} />
      ))}
    </div>
  );
};
